export interface BeforeUnloadTarget {
  addEventListener(
    type: 'beforeunload',
    listener: (event: BeforeUnloadEvent) => void,
  ): void;
  removeEventListener(
    type: 'beforeunload',
    listener: (event: BeforeUnloadEvent) => void,
  ): void;
}

export interface ActiveHostRefreshGuardOptions {
  hasConnectedPlayers: () => boolean;
  target?: BeforeUnloadTarget;
}

export function installActiveHostRefreshGuard({
  hasConnectedPlayers,
  target = window,
}: ActiveHostRefreshGuardOptions) {
  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    if (!hasConnectedPlayers()) {
      return;
    }

    event.preventDefault();
    event.returnValue = '';
  };

  target.addEventListener('beforeunload', handleBeforeUnload);
  return () => target.removeEventListener('beforeunload', handleBeforeUnload);
}
